import React from "react";
import AdminView from './../../components/views/admin-view/AdminView';

export default function AdminPage() {
  return <AdminView />;
}
